<template>
  <div class="laypanel">
    <el-row class="querypanel">
      <el-col :span="24">
        <div>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="addfxy">增加分销员</el-button>
          <el-button style="margin-top: 10px; margin-left: 10px;" @click="querfxy">查询分销员</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row class="querypanel">
      <el-table
        stripe
        :data="fxydata"
        ref="multipleTable">
        <el-table-column
          prop="id.Int64"
          label="ID">
        </el-table-column>
        <el-table-column
          prop="username"
          label="分销员昵称">
        </el-table-column>
        <el-table-column
          prop="level"
          label="等级">
        </el-table-column>
        <el-table-column
          label="审核状态"
          min-width="60px">
          <template slot-scope="scope">
            <div v-if="scope.row.state === 1">
              已审核
            </div>
            <div v-else>
              未审核
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="80px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="确认审核" placement="top-start">
              <i class="fa fa-eye fa-lg ciicon curpointer" v-on:click="shinfo(scope.$index, fxydata)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除分销人员" placement="top-start">
              <i class="fa fa-trash-o ciicon fa-lg curpointer" v-on:click="delsh(scope.$index, fxydata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-dialog title="添加分销员信息" :visible.sync="visfxy">
      <el-table
        stripe
        :data="memberdata"
        ref="multipleTable">
        <el-table-column
          prop="nickname.String"
          width = "200px"
          label="会员昵称">
        </el-table-column>
        <el-table-column
          label="头像">
          <template slot-scope="scope">
            <div v-if="scope.row.imgurl.Valid && scope.row.imgurl.String !== ''">
              <img :src="scope.row.imgurl.String" class="avatarimg">
            </div>
            <div v-else>
              {{scope.row.imgurl.String}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="phone.String"
          label="电话号码">
        </el-table-column>
        <el-table-column
          label="操作"
          width="120px"
        >
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="开通分销员权限" placement="top-start">
              <i class="fa fa-pencil-square-o opicon curpointer" v-on:click="openfxy(scope.$index, memberdata)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import '../../../static/css/my.css'
Vue.prototype.$http = axios
var that
export default {
  name: 'FxControl',
  data () {
    return {
      khid: '',
      fxydata: [],
      memberdata: [],
      visfxy: false
    }
  },
  mounted: function () {
    var v = getCookie('cusid')
    this.khid = v
    that = this
    if (that.khid === null) {
      that.$message({
        type: 'info',
        message: 'Cookie已失效，请重新登录!'
      })
      that.$router.push({path: '/'})
    } else {
    }
  },
  methods: {
    addfxy: function () {
      console.log('增加分销员')
      this.visfxy = true
      var qstr = 'usergroups_id = 1 and cus_id= ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/account/getuserlist',
        method: 'post',
        data: {
          whereinfo: {String: qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            console.log(JSON.parse(res.data.data))
            that.memberdata = JSON.parse(res.data.data)
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    querfxy: function () {
      this.fxinfolist = []
      var qstr = 'cusid = ' + this.khid
      that.$http({
        url: 'https://api.sqnetsoft.cn/subsale/gssr',
        method: 'post',
        data: {
          whereinfo: {'String': qstr, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          if (res.data.success) {
            if (res.data.data !== '[]') {
              that.fxydata = JSON.parse(res.data.data)
            }
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    shinfo: function (index, data) {
      var row = data[index]
      console.log(data[index])
      this.$confirm('确定审核通过客户 "' + row.username + '" 吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        that.$http({
          url: 'https://api.sqnetsoft.cn/subsale/ussr',
          method: 'post',
          data: {
            fieldparams: {'String': 'state=1', Valid: true},
            whereinfo: {'String': 'id=' + row.id.Int64, Valid: true}
          },
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            console.log(res)
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '审核成功!'
              })
              var qstr3 = 'cusid = ' + that.khid
              that.$http({
                url: 'https://api.sqnetsoft.cn/subsale/gssr',
                method: 'post',
                data: {
                  whereinfo: {'String': qstr3, Valid: true}
                },
                headers: {
                  'Content-Type': 'application/json'
                }
              })
                .then(function (res) {
                  if (res.data.success) {
                    if (res.data.data !== '[]') {
                      that.fxydata = JSON.parse(res.data.data)
                    }
                  }
                })
                .catch(function (error) {
                  console.log('error' + error)
                })
            } else {
              that.$message({
                type: 'error',
                message: '审核失败!'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消审核'
        })
      })
    },
    delsh: function (index, data) {
      var selectdata = data[index]
      var dataindex = data.findIndex(d => d.id.Int64 === selectdata.id.Int64)
      // 移除该条数据
      data.splice(dataindex, 1)
      that.$http({
        url: 'https://api.sqnetsoft.cn/subsale/dssr',
        method: 'post',
        data: {
          whereinfo: {'String': 'id=' + selectdata.id.Int64, Valid: true}
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(function (res) {
          console.log(res)
          if (res.data.success) {
            that.$message({
              type: 'success',
              message: '删除成功!'
            })
          }
        })
        .catch(function (error) {
          console.log('error' + error)
        })
    },
    openfxy: function (index, data) {
      console.log(data[index])
      var datatmp = data[index]
      this.$confirm('确定要把 "' + datatmp.name.String + '"提升为分销吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info'
      }).then(() => {
        var adddata = {
          userid: parseInt(datatmp.id),
          username: datatmp.name.String,
          parentid: parseInt(-1),
          level: parseInt(1),
          haschild: parseInt(0),
          state: parseInt(1),
          cusid: parseInt(this.khid)
        }
        that.$http({
          url: 'https://api.sqnetsoft.cn/subsale/aaussr',
          method: 'post',
          data: adddata,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(function (res) {
            if (res.data.success) {
              that.$message({
                type: 'success',
                message: '已提升成功'
              })
            }
          })
          .catch(function (error) {
            console.log('error' + error)
          })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '取消改变'
        })
      })
    }
  }
}
function getCookie (name) {
  var v = window.document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)')
  return v ? v[2] : null
}
</script>



// WEBPACK FOOTER //
// src/components/control/FxControl.vue